module.exports = __webpack_public_path__ + "static/media/bg-purple-top.9dd6a28d.png";